import axios from 'axios';
import {
    Message,
    MessageResult,
    MessageListResult
} from '../models/message';

const locked = {
    getMessages: false,
    getUnreadMessages: false
};

export const sendRequestRefills = async (medIds: number[]): Promise<void> => {
    await axios.post(`/api/messaging-msg/send-request-refill`, medIds);
};

export const createChatMessage = async (message: Message): Promise<MessageResult> => {
    const response = await axios.post(`/api/messaging-msg/chat`, message);
    return response.data;
};

export const getMessages = async (
    rootMessageId: Undefinable<number>,
    time: Undefinable<string>
): Promise<Undefinable<Message[]>> => {
    if (!locked.getMessages) {
        locked.getMessages = true;
        try {
            const response = await axios.get(`/api/messaging-msg/params?rootMessageId=${rootMessageId}&time=${time}`);
            locked.getMessages = false;
            return response.data;
        } catch (e) {
            locked.getMessages = false;
            throw e;
        }
    }
};

export const getUnreadMessages = async (): Promise<Undefinable<Message[]>> => {
    if (!locked.getUnreadMessages) {
        locked.getUnreadMessages = true;
        try {
            const response = await axios.get(`/api/messaging-msg/unread`);
            locked.getUnreadMessages = false;
            return response.data;
        } catch (e) {
            locked.getUnreadMessages = false;
            throw e;
        }
    }
};

export const readMessages = async (rootMessageId: number): Promise<MessageListResult> => {
    const response = await axios.post(`/api/messaging-msg/read/${rootMessageId}`);
    return response.data;
};

export const getRootMessages = async (): Promise<Undefinable<Message[]>> => {
    const response = await axios.get(`/api/messaging-msg/root-message`);
    return response.data;
};
